import type { NewsItem } from "@/types/media";

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "2026年度春节档电影片单曝光，多部科幻巨制集结",
    summary:
      "随着春节档临近，多部备受期待的大制作电影陆续官宣定档，科幻题材成为今年最大亮点，引发观众广泛讨论。",
    content: [
      "随着春节档的脚步日益临近，多部备受瞩目的电影陆续官宣定档。从目前公布的片单来看，科幻、悬疑与合家欢题材将构成今年春节档的主力阵容。",
      "业内分析人士指出，观众对高质量视效与原创故事的期待持续走高，这促使制片方在剧本打磨与特效制作上投入更多精力。多部作品均采用了前沿的虚拟制片技术。",
      "此外，动画电影同样看点十足，多部国产动画续作将加入竞争。影院方面也已开始筹备各类观影活动，以迎接即将到来的观影高峰。",
    ],
    category: "新闻",
    date: "2026-02-08",
    author: "飘花资讯",
    cover:
      "https://readdy.ai/api/search-image?query=cinema%20hall%20with%20large%20glowing%20screen%20and%20rows%20of%20empty%20red%20seats%2C%20warm%20ambient%20lighting%2C%20modern%20movie%20theater%20interior%2C%20cinematic%20atmosphere&width=640&height=400&seq=ph-news-01&orientation=landscape",
  },
  {
    id: "n2",
    title: "专题：走进经典科幻电影的视觉美学世界",
    summary:
      "从冷峻的宇宙景观到恢弘的星际飞船，经典科幻电影如何构建令人信服的未来世界？本期专题带你一探究竟。",
    content: [
      "科幻电影之所以令人着迷，不仅在于天马行空的想象，更在于其构建世界时展现的严谨美学与视觉逻辑。",
      "本期专题梳理了多部经典科幻作品在美术设计上的巧思：从配色方案到建筑语言，从光影运用到质感细节，每一处都经过反复推敲。",
      "正是这些看似微不足道的细节，共同编织出一个令人信服的未来世界，让观众在两个小时里彻底沉浸其中。",
    ],
    category: "专题",
    date: "2026-02-06",
    author: "专题编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20sci-fi%20concept%20art%2C%20vast%20glowing%20space%20station%20floating%20above%20a%20blue%20planet%2C%20cool%20cyan%20and%20deep%20navy%20palette%2C%20epic%20cinematic%20digital%20painting&width=640&height=400&seq=ph-news-02&orientation=landscape",
  },
  {
    id: "n3",
    title: "影评：《星际穿越》为什么依然让人热泪盈眶",
    summary:
      "十余年过去，这部太空史诗依然被反复讨论。它真正打动观众的，或许并非宏大的宇宙，而是那句关于爱与时间的承诺。",
    content: [
      "当飞船驶入土星旁的虫洞，当时间在陌生星球上被无限拉长，观众才真正理解这部作品的核心并非科幻，而是情感。",
      "影片用相对论的外壳，包裹着一个关于父女之间承诺的朴素故事。正是这种宏大与细微之间的强烈反差，让无数观众在结尾处潸然泪下。",
      "十多年后再看，它依然证明：最动人的科幻，永远是关于人的故事。",
    ],
    category: "影评",
    date: "2026-02-04",
    author: "影评人 · 林一",
    cover:
      "https://readdy.ai/api/search-image?query=cosmic%20nebula%20and%20distant%20galaxy%20with%20a%20small%20spacecraft%20silhouette%2C%20deep%20blue%20violet%20and%20amber%20nebula%20colors%2C%20awe%20inspiring%20space%20scene&width=640&height=400&seq=ph-news-03&orientation=landscape",
  },
  {
    id: "n4",
    title: "多部高分剧集宣布续订，观众期待值持续攀升",
    summary:
      "平台方近期陆续公布多部热门剧集的续订计划，原班人马回归成为主旋律，社交平台讨论热度居高不下。",
    content: [
      "近期，多家影视平台陆续公布了一批热门剧集的续订消息，涵盖古装、悬疑与家庭等多种题材。",
      "据了解，多部续作将启用原班人马，以保持角色与叙事风格的一致性。制作方表示，新一季将在剧本与制作水准上进一步升级。",
      "消息公布后，相关话题迅速登上社交平台热搜榜，观众的期待值可见一斑。",
    ],
    category: "新闻",
    date: "2026-02-03",
    author: "飘花资讯",
    cover:
      "https://readdy.ai/api/search-image?query=creative%20video%20production%20studio%20with%20camera%20and%20lighting%20equipment%2C%20warm%20practical%20lights%20against%20dark%20background%2C%20professional%20cinematic%20behind%20the%20scenes&width=640&height=400&seq=ph-news-04&orientation=landscape",
  },
  {
    id: "n5",
    title: "专题：国产悬疑剧的黄金年代是如何到来的",
    summary:
      "从叙事结构到影像质感，国产悬疑剧在近几年完成了质的飞跃。本期专题解析这一类型崛起背后的创作密码。",
    content: [
      "近些年来，国产悬疑剧凭借扎实的剧本与电影级的制作水准，赢得了口碑与市场的双重认可。",
      "与传统电视剧不同，这类作品往往采用更紧凑的节奏与更复杂的叙事结构，在有限篇幅内构建强烈的悬念张力。",
      "与此同时，平台与制作方对原创内容的重视，也为创作者提供了更大的发挥空间，共同推动了这一类型的繁荣。",
    ],
    category: "专题",
    date: "2026-01-30",
    author: "专题编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20neon-lit%20narrow%20city%20alley%20at%20night%2C%20reflections%20on%20wet%20pavement%2C%20cool%20teal%20and%20deep%20blue%20tone%2C%20suspenseful%20cinematic%20mood&width=640&height=400&seq=ph-news-05&orientation=landscape",
  },
  {
    id: "n6",
    title: "影评：《请回答1988》为何被称为“治愈神剧”",
    summary:
      "没有惊天动地的情节，却让无数观众笑着流泪。这部作品用最日常的细节，还原了记忆里最温暖的旧时光。",
    content: [
      "在节奏日益加快的当下，这部作品像一股清流，用缓慢而细腻的笔触描绘邻里之间的烟火日常。",
      "它没有反派，也没有狗血冲突，所有的动人之处都藏在饭菜的香气、母亲的唠叨和朋友的玩笑里。",
      "正因如此，观众才能在某个瞬间突然热泪盈眶——因为那正是我们每个人都曾拥有过的、再也回不去的旧时光。",
    ],
    category: "影评",
    date: "2026-01-27",
    author: "影评人 · 苏晓",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20old%20neighborhood%20alley%20at%20dusk%20with%20string%20lights%20and%20potted%20plants%2C%20warm%20golden%20and%20muted%20green%20tone%2C%20nostalgic%20heartwarming%20scene&width=640&height=400&seq=ph-news-06&orientation=landscape",
  },
  {
    id: "n7",
    title: "第42届华语电影金像奖提名名单正式公布",
    summary:
      "本届提名名单涵盖多部口碑佳作，新生代演员与实力派戏骨同台竞技，多项奖项竞争格外激烈。",
    content: [
      "第42届华语电影金像奖提名名单日前正式揭晓，多部叫好又叫座的作品入围重要奖项。",
      "本届评选中，既有资深电影人带来的厚重之作，也有新生代导演与演员的大胆尝试，展现出华语电影多元并进的创作活力。",
      "颁奖典礼将于下月举行，最终花落谁家，值得期待。",
    ],
    category: "新闻",
    date: "2026-01-22",
    author: "飘花资讯",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20awards%20ceremony%20stage%20with%20golden%20spotlights%20and%20red%20carpet%2C%20dramatic%20warm%20and%20dark%20contrast%2C%20luxurious%20cinematic%20venue&width=640&height=400&seq=ph-news-07&orientation=landscape",
  },
  {
    id: "n8",
    title: "专题：从胶片到数字，电影影像技术的百年变迁",
    summary:
      "一项技术如何改变一门艺术？回顾电影诞生以来影像技术的演进，我们看到的不只是设备，更是叙事方式的革命。",
    content: [
      "从早期的黑白默片到如今的高帧率沉浸式影像，电影技术的每一次跃迁都深刻影响了创作者的表达方式。",
      "数字技术的普及，让拍摄门槛大幅降低，也让特效与后期制作的可能性被无限放大。",
      "然而无论技术如何迭代，打动人心的始终是故事本身——技术只是让故事有了更好的讲述方式。",
    ],
    category: "专题",
    date: "2026-01-18",
    author: "专题编辑部",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20film%20reels%20and%20camera%20lenses%20arranged%20on%20a%20wooden%20table%2C%20warm%20sepia%20and%20amber%20tone%2C%20nostalgic%20retro%20cinema%20still%20life&width=640&height=400&seq=ph-news-08&orientation=landscape",
  },
  {
    id: "n9",
    title: "影评：一场关于时间与选择的温柔告别",
    summary:
      "如果说大多数电影在讲述“得到”，那么这部作品讲述的则是“放下”。它用克制的镜头，道出了成长最真实的样子。",
    content: [
      "影片没有刻意煽情，而是用大量留白与沉默，让情绪在观众心中慢慢发酵。",
      "主角的每一次犹豫与抉择，都像极了现实中的我们——在得到与失去之间反复权衡。",
      "结尾处那个安静的镜头，胜过千言万语。它告诉我们，告别并不总是遗憾，有时也是一种成全。",
    ],
    category: "影评",
    date: "2026-01-15",
    author: "影评人 · 陈默",
    cover:
      "https://readdy.ai/api/search-image?query=solitary%20figure%20standing%20on%20a%20quiet%20beach%20at%20sunset%2C%20soft%20muted%20pastel%20sky%2C%20reflective%20melancholic%20cinematic%20mood&width=640&height=400&seq=ph-news-09&orientation=landscape",
  },
];